import { gql } from "@apollo/client";
export const UPDATESETTINGS = gql`
  mutation updateSettings($key: String!, $value: String!) {
    setSetting(key: $key, value: $value) {
      id
    }
  }
`;
